import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.todo');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-todo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.todo/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminTodoComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public loaded: boolean = false;
    public statusFilter: string = '';
    public newTitle: string = '';
    public newPriority: string = 'normal';
    public newDueDate: string = '';
    public editingId: string = '';
    public editingTitle: string = '';

    public summary: any = { total: 0, due_today: 0, overdue: 0 };

    public priorityMap: any = { urgent: '긴급', high: '높음', normal: '보통', low: '낮음' };
    public priorityColorMap: any = {
        urgent: 'bg-red-100 text-red-700',
        high: 'bg-orange-100 text-orange-700',
        normal: 'bg-blue-100 text-blue-700',
        low: 'bg-zinc-100 text-zinc-500'
    };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.loadSummary();
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("search", { status: this.statusFilter });
        if (code == 200) {
            this.items = data.rows || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public async loadSummary() {
        const { code, data } = await wiz.call("summary");
        if (code == 200) {
            this.summary = data;
            await this.service.render();
        }
    }

    public async add() {
        if (!this.newTitle.trim()) return;
        const params: any = { title: this.newTitle, priority: this.newPriority };
        if (this.newDueDate) params.due_date = this.newDueDate;
        const { code } = await wiz.call("create", params);
        if (code == 200) {
            this.newTitle = '';
            this.newDueDate = '';
            this.newPriority = 'normal';
            await this.load();
            await this.loadSummary();
        }
    }

    public async toggleDone(item: any) {
        const { code, data } = await wiz.call("toggle", { id: item.id });
        if (code == 200) {
            item.status = data.status;
            await this.loadSummary();
            await this.service.render();
        }
    }

    public async startEdit(item: any) {
        this.editingId = item.id;
        this.editingTitle = item.title;
        await this.service.render();
    }

    public async saveEdit(item: any) {
        if (!this.editingTitle.trim()) return;
        await wiz.call("update", { id: item.id, title: this.editingTitle });
        item.title = this.editingTitle;
        this.editingId = '';
        await this.service.render();
    }

    public cancelEdit() {
        this.editingId = '';
        this.service.render();
    }

    public async deleteItem(item: any) {
        const res = await this.service.alert.show({
            title: '삭제',
            message: '이 할 일을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!res) return;
        const { code } = await wiz.call("delete", { id: item.id });
        if (code == 200) {
            await this.load();
            await this.loadSummary();
        }
    }

    public async filterByStatus(status: string) {
        this.statusFilter = this.statusFilter === status ? '' : status;
        await this.load();
    }

    public async updatePriority(item: any, priority: string) {
        await wiz.call("update", { id: item.id, priority });
        item.priority = priority;
        await this.service.render();
    }

    public isOverdue(item: any) {
        if (!item.due_date || item.status === 'done') return false;
        return item.due_date < new Date().toISOString().split('T')[0];
    }
}

export default PortalLpsysadminTodoComponent;